import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getHistoryOilDelivering, getConsolidateOilDelivering } from '../../actions/oilActions'
import OilRecordView from '../../containers/Oil/OilRecordEcoUser/OilRecordEcoUser'

const OilRecord = () => {
  const dispatch = useDispatch();

  const { userInfo } = useSelector(state => state.userInfo);
  const { totalPointsDelivery } = useSelector(state => state.oil);
  const { totalLitersDelivery } = useSelector(state => state.oil);
  const { historicalDelivery } = useSelector(state => state.oil);
  const [skipHistoricalDelivery, setSkipHistoricalDelivery] = useState(0)
  const auxHistoricalDelivery = [];
  const limitHistoricalDelivery = 20;

  useEffect(() => {
    if (userInfo._id) {
      dispatch(getConsolidateOilDelivering(userInfo._id));
    }

    return () => { }
  }, [userInfo])

  useEffect(() => {
    if (userInfo._id) {
      dispatch(getHistoryOilDelivering(userInfo._id, limitHistoricalDelivery, skipHistoricalDelivery));
    }

    return () => {
    }
  }, [userInfo, skipHistoricalDelivery])

  if (auxHistoricalDelivery) {

    historicalDelivery.forEach((delivery) => {
      auxHistoricalDelivery.push(
        {
          id: delivery._id,
          date: new Date(delivery.creationDate).toLocaleDateString(),
          quantity: delivery.liters,
          ecopoints: delivery.pointsReceived,
        }
      );
    });
  }

  return (
    <OilRecordView
      historicalDelivery={auxHistoricalDelivery}
      limitHistoricalDelivery={limitHistoricalDelivery}
      skipHistoricalDelivery={skipHistoricalDelivery}
      setSkipHistoricalDelivery={setSkipHistoricalDelivery}
      totalPointsDelivery={totalPointsDelivery}
      totalLitersDelivery={totalLitersDelivery}
    />
  )
}

export default OilRecord